import React, {Component} from 'react';
import { connect } from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";
import { isMobile,isJSON } from "../../utils/util";
import './Blog.css';
import BlogItem from './BlogItem';
import Slider from 'react-slick';
// import Api from '../../utils/api';
import Http from '../../utils/http';

class Blog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articlesData:[
               
            ],
            contentHtml:'',
            blogId: 92681994,
        };

    }

    componentWillMount() {

    }

    componentDidMount() {
        this.fun_getBlogArtivlesData();
    }

    fun_getBlogArtivlesData(){
        Http.get(`/api/blogs/${this.state.blogId}/articles`,false).then(Response =>{
            this.setState({
                articlesData:Response
            })
          this.fun_PhoneBranchTopPosition();
        }).catch(err =>{

        })
    }

    fun_PhoneBranchTopPosition(){
      var oDiv;
      if(!isMobile(navigator.userAgent) && window.location.pathname == "/" ){
          oDiv = document.getElementById('promo-banner');
      }else{
          oDiv = document.getElementById('promo-banner-container-second');
      }
  
      var content = document.getElementById('content-container');
      try {
        var bannerHeight = oDiv.offsetHeight;
        content.style.paddingTop = (bannerHeight)+"px";
        document.getElementById("phone-recommendations-navigation-area").style.top =  document.getElementById("promo-banner-container-second").offsetHeight +'px';
        } catch (error) {}
    }

    fun_createArticlesContenHtml(){
        const blogDom = this.state.articlesData.map((product, index)=>{
            return (
                <BlogItem product={product} blogId={this.state.blogId}></BlogItem>
            )
        })
        return blogDom;
    }

    next() {
		this.slider.slickNext();
	}

	previous() {
		this.slider.slickPrev();
	}

    render() {

        const sliderSettings = {
            dots: true,
            infinite: false,
            speed: 250,
            slidesToShow: 3,
            slidesToScroll: 1,
            className: "ha-slider-blog",
            arrows:true,
            responsive: [
                {
                  breakpoint: 1445,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    arrows:true,
                    className: "ha-slider-blog"
                  }
                },
                {
                  breakpoint: 1327,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    arrows:true,
                    className: "ha-slider-blog"
                  }
                },
                {
                  breakpoint: 1180,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    arrows:true,
                    className: "ha-slider-blog"
                  }
                },
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows:false,
                    className: "ha-slider-blog"
                  }
                },
                {
                  breakpoint: 552,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                    className: "ha-slider-blog"
                  }
                },
                {
                  breakpoint: 320,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false,
                    className: "ha-slider-blog"
                  }
                }
              ],
            appendDots: () => (
              <div></div>
            )
          };
     
        return (
            <div className="home">
                <Helmet>
                    <title>HelloAva - The Brains Behind Your Beauty</title>
                    <meta name="description" content="Discover the best skincare products for your skin's unique needs, powered by artificial intelligence and human expertise." />
                </Helmet>
                <div className="blog-content-area">
                    <div className="blog">
                        <div className="blog-home-title">Ava Academy</div>
                        <div className="blog-home-title-deail">Read more on how HelloAva has transformed thousands of skincare journeys</div>
{/*                         
                        <div className="blog-home-conten">
                            <div className="blog-home-conten-title">Hello Skin Guide 101</div>
                            <div className="blog-home-conten-side" style={{marginLeft:'-0.4rem'}} >
                                <Slider ref={c => (this.slider = c)} { ...sliderSettings } >
                                    {this.fun_createArticlesContenHtml() }
                                </Slider>
                            </div>
                        </div> */}



                        <div className="blog-home-conten-allPosts">
                            <div className="blog-home-conten-side blog-home-conten-all">
                                {this.fun_createArticlesContenHtml() }
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps, null)(Blog));



// WEBPACK FOOTER //
// ./src/views/blog/Blog.js